import { HashRouter as Router } from 'react-router-dom';
import type { ChildrenProps } from 'types';

const RouterSetting = ({ children }: ChildrenProps) => (
  <Router>{children}</Router>
);

export default RouterSetting;
